import request, { BaseResponse } from "../core";

export const postSurvey = async (data: any, token: string) => {
  return await request.post<BaseResponse<boolean>>(
    `/app/survey/user-info`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
